var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notfound-container"},[_vm._v("\n    页面不存在\n")])}
var staticRenderFns = []

export { render, staticRenderFns }